import React, { useState } from 'react'
import { getCustomIntro } from './functions/ShortIntro'
import BounceLoader from "react-spinners/BounceLoader";
import { css } from "@emotion/core";
// import { getCustomLinkedinV2 } from './functions/Linkedin';
import { customCopy } from './functions/CustomCopy';
import { customApprove } from './functions/CustomApprove';
import { HeartIcon, DuplicateIcon } from '@heroicons/react/solid';
import EditCustomCreate from './EditCustomCreate';



const override = css`
  display: inline-block;
  margin: 20px;
`;


function CustomCreate({
    FBvalueProp,
    auth,
    fbProfile,
    tokens,
    interestValues,
    callToAction,
    firstCopy,
    teamToken,
    tokensTeam
}) {

    const [ vProp, setVprop ] = useState('')
    const [ int, setInt ] = useState('')
    const [ name, setName ] = useState('')
    const [ content, setContent ] = useState('')
    const [ generating, setGenerating ] = useState(false)
    const [ msgType, setMsgType ] = useState('')
    const [ prevName, setPrevName ] = useState('')
    const [ docID, setDocID ] = useState('')
    const [ btnClicked, setBtnClicked ] = useState(false)
    const [ editing, setEditing ] = useState(false)
    const [ editedContent, setEditedContent ] = useState(content)


    const clickSI = () =>{

        if(vProp?.ContextType === "template"){
            setMsgType("Template Model")
            getCustomIntro(
                fbProfile,
                vProp,
                int,
                auth,
                setContent,
                setGenerating,
                tokens,
                docID,
                name,
                setDocID,
                setPrevName,
                prevName,
                interestValues,
                msgType,
                callToAction,
                setBtnClicked,
                setEditing,
                teamToken,
                tokensTeam
            )
        } else{
        setMsgType("ShortIntro")
        getCustomIntro(
            fbProfile,
            vProp,
            int,
            auth,
            setContent,
            setGenerating,
            tokens,
            docID,
            name,
            setDocID,
            setPrevName,
            prevName,
            interestValues,
            msgType,
            callToAction,
            setBtnClicked,
            setEditing,
            teamToken,
            tokensTeam
        )
        }
    }


    // const clickLinkedin = () =>{
    //     setMsgType("Linkedin")
    //     getCustomLinkedinV2(
    //         fbProfile,
    //         vProp,
    //         int,
    //         auth,
    //         setContent,
    //         setGenerating,
    //         tokens,
    //         docID,
    //         name,
    //         setDocID,
    //         setPrevName,
    //         prevName,
    //         interestValues,
    //         msgType,
    //         callToAction,
    //         setBtnClicked,
    //         setEditing
    //     )
    // }

    const handleEditBtn = () => {
        setEditing(true)
        setEditedContent(content)
    }

    return (
        <div className="p-4 m-4 grid">
            <p className="my-1 font-medium">
                First Name
            </p>
            <input 
            placeholder="Prospect First Name"
            className="border-2 border-gray-200 p-1 rounded-lg focus:ring focus:outline-none"
            onChange={(e) => setName(e.target.value)}
            />
            <p className=" mt-2 font-medium">
                Company Info
            </p>
            <select
            className="my-2 border-2 border-gray-200 p-1 text-gray-600 rounded-lg focus:ring focus:outline-none"
            onChange={(e) => setVprop(FBvalueProp[e.currentTarget.value])}
            defaultValue="default"
            >
                <option value="default">Select a value prop...</option>
                {FBvalueProp !== '' ? FBvalueProp.map((vprop, index) =>{
                    return(
                        <option value={index} key={index}>
                            {vprop.Title}
                        </option>
                            )
                    })
                    :
                    null
                }
            </select>
            <p className="my-1 font-medium">
                Topic
            </p>
            <input 
            placeholder="Topic to write about (Ex: Soccer)"
            className="border-2 border-gray-200 p-1 rounded-lg focus:ring focus:outline-none"
            onChange={(e) => setInt(e.target.value)}
            />
            
            <div className="flex mt-1">
                <button 
                    className="border-2 mt-4 border-green-700 bg-green-700 text-white px-4 py-2 text-base font-semibold focus:outline-none focus:ring hover:bg-green-600 rounded-lg"
                    onClick={() => clickSI()}
                    disabled={(name === '' || int === '' || vProp === '' ) || (generating === true) || (tokens?.totalTokens < 1) || (teamToken?.[0]?.teamToken && tokensTeam < 1) ? true : false}
                >
                    Create
                </button>
                {/* <button 
                    className="border-2 ml-4 border-blue-500 bg-blue-700 text-white px-4 py-2 text-base font-semibold focus:outline-none focus:ring hover:bg-blue-400 rounded-lg"
                    disabled={(name === '' || int === '' || vProp === '' ) || (generating === true) ? true : false}
                    onClick={() => clickLinkedin()}
                >
                    Linkedin
                </button> */}
            </div>
            {/* Show the content that's generated here */}
            <div className="mt-6">
                {generating ? 
                <div className="text-center">
                <BounceLoader size={100} css={override} color='#44A3CE'/>
                {/*Look at changing the text as it searches  */}
                <p className="text-xl font-semibold">Generating Message</p> 
                </div>
                :
                (content !== '' ? 
                (editing ? 
                    //editing will be here
                    <div>
                        <EditCustomCreate 
                        content={content}
                        editedContent={editedContent}
                        setEditedContent={setEditedContent}
                        setEditing={setEditing}
                        setContent={setContent}
                        fbProfile={fbProfile}
                        auth={auth}
                        docId={docID}
                        />
                    </div>
                : 
                <div className="text-left whitespace-pre-line p-6 border-2 border-gray-200 rounded-md shadow">
                    {editing ? null 
                    :
                    <button 
                        className="float-right mr-2 border-2 border-gray-400 bg-gray-200 focus:outline-none hover:bg-gray-600 px-2 py-0.5 hover:text-white rounded-md"
                        onClick={() => handleEditBtn()}
                    >
                        Edit
                    </button>
                    }
                    <div className='mt-3'>
                    {content}
                    </div>
                    <div className="mt-6">
                        <button 
                            className="border-2 border-green-200 bg-green-500 text-white hover:bg-green-800 focus:outline-none px-2 py-1 rounded "
                            onClick={() => customCopy(
                                content,
                                fbProfile,
                                docID,
                                vProp,
                                int,
                                msgType,
                                firstCopy,
                                name,
                                auth
                            )}
                        >
                            <span className='flex'>
                                <DuplicateIcon className="h-5 mr-2"/>Copy
                            </span>
                        </button>
                        {btnClicked ? null :
                        <button 
                            className="border-2 ml-4 border-red-200 bg-red-500 text-white hover:bg-red-800 focus:outline-none px-2 py-1 rounded"
                            onClick={() => customApprove(
                                fbProfile,
                                content,
                                int,
                                vProp,
                                docID,
                                msgType,
                                setBtnClicked,
                                name,
                                auth
                            )}
                        >
                            <span className='flex'>
                            <HeartIcon className="h-5 mr-2" />Save 
                            </span>
                        </button>
                        }
                    </div>
                </div>
                )
                :
                null
                )
                }
            </div>
        </div>
    )
}

export default CustomCreate
